<template>
    <div v-html="content_html"></div>
</template>

<script>
    export default {
        name: "TextWithDictionary",
        props: {
            content: String
        },
        data: () => {
            return {
                content_html: null
            }
        },
        mounted() {
            axios.post('/enviro-komunita/preklad', {
                content: this.content
            }).then(response => {
                this.content_html = response.data
            }).catch(error => {

            });
        }
    }
</script>

<style scoped>

</style>
